
import { count } from 'console';
import * as tools from '../Tools';

export class Slave {

    protected container : NodeListOf<HTMLElement>;
    protected interval : HTMLInputElement;
    protected running : boolean = false;
    protected stateFields = {
        'state' : HTMLElement = null,
        'Master_Log_File' : HTMLElement = null,
        'Read_Master_Log_Pos' : HTMLElement = null,
        'Relay_Log_File' : HTMLElement = null,
        'Relay_Log_Pos' : HTMLElement = null,
        'Relay_Master_Log_File' : HTMLElement = null,
        'Slave_IO_Running' : HTMLElement = null,
        'Slave_SQL_Running' : HTMLElement = null,
    };

    protected stats = [];
    protected counter = 0;

    constructor() {
        this.container = document.querySelectorAll('.admin-container');
        if (!this.container.length) {
            return;
        }
        this.interval = <HTMLInputElement>document.getElementById('envInterval');
        const _this = this;

        this.stateFields.state = <HTMLElement>document.getElementById('state');
        this.stateFields.Master_Log_File = <HTMLElement>document.getElementById('Master_Log_File');
        this.stateFields.Read_Master_Log_Pos = <HTMLElement>document.getElementById('Read_Master_Log_Pos');
        this.stateFields.Relay_Log_File = <HTMLElement>document.getElementById('Relay_Log_File');
        this.stateFields.Relay_Log_Pos = <HTMLElement>document.getElementById('Relay_Log_Pos');
        this.stateFields.Relay_Master_Log_File = <HTMLElement>document.getElementById('Relay_Master_Log_File');
        this.stateFields.Slave_IO_Running = <HTMLElement>document.getElementById('Slave_IO_Running');
        this.stateFields.Slave_SQL_Running = <HTMLElement>document.getElementById('Slave_SQL_Running');

        window.setTimeout( () => {
            _this.getState();
        }, parseInt(this.interval.value) );

    }

    async getState() {
        const _this = this;
        if (_this.running) {
            return;
        }
        _this.counter++;
        _this.running = true;
        let r = await tools.fetchJSON('/Handler/HvD/Admin?state');
        console.log(r);
        if (_this.stats.length >= 10) {
            _this.stats.shift;
        }
        _this.stats.push(r.Relay_Log_Pos);

        (<HTMLElement>this.stateFields.Master_Log_File).innerHTML = r['Master_Log_File'];
        (<HTMLElement>this.stateFields.Read_Master_Log_Pos).innerHTML = r['Read_Master_Log_Pos'];
        (<HTMLElement>this.stateFields.Relay_Log_File).innerHTML = r['Relay_Log_File'];
        (<HTMLElement>this.stateFields.Relay_Log_Pos).innerHTML = '<b>' + r.Relay_Log_Pos + '</b>[ last: <i>' + _this.stats[_this.stats.length-2] + '</i> ]';
        (<HTMLElement>this.stateFields.Relay_Master_Log_File).innerHTML = r['Relay_Master_Log_File'];
        (<HTMLElement>this.stateFields.Slave_IO_Running).innerHTML = r['Slave_IO_Running'];
        (<HTMLElement>this.stateFields.Slave_SQL_Running).innerHTML = r['Slave_SQL_Running'];

        if (r.running) {
            (<HTMLElement>this.stateFields.state).innerHTML = '<i class="icon icon-ok"></i>';
        } else {
            (<HTMLElement>this.stateFields.state).innerHTML = '<i class="icon icon-attention"></i>';
        }
        _this.running = false;
        window.setTimeout( () => {
            _this.getState();
        }, parseInt(_this.interval.value) );
    }
}
